import templateUrl from "emun.cart/order-questions-prompt.htm";
import OrderQuestionsPromptController from "emun.cart/order-questions-prompt.controller";
import open from "webmodals/open";

let OrderQuestionsPrompt = options => {
  let modalInstance = open({
	  size: options.size || "md",
	  backdrop: "static",
    templateUrl: options.templateUrl || templateUrl,
    controller: OrderQuestionsPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default OrderQuestionsPrompt;
